import {Component, Input} from '@angular/core';
import {EmployeeEvent} from "../../../../models/event/employee-event";
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {EventService} from "../../_services/event.service";
import {FormsModule} from "@angular/forms";
import {EmployeeEventResponseSummary} from "../../../company/_models/employee/employee-event-response-summary";
import {GlobalAlertService} from "../../../../_services/global-alert.service";
import {IcsService} from "../../_services/ics.service";


@Component({
  selector: 'app-event-display',
  imports: [
    DatePipe,
    NgClass,
    FormsModule,
    NgIf,
    NgForOf
  ],
  templateUrl: './event-display.component.html',
  styleUrl: './event-display.component.scss'
})
export class EventDisplayComponent {
  @Input() event!: EmployeeEvent;
  @Input() responses: EmployeeEventResponseSummary[] = [];

  /** #664 — the card chips a virtual event; the template needs the enum to say which. */

  constructor(public eventService: EventService,
              private gas: GlobalAlertService,
              protected IcsService: IcsService) {
  }

  canRespond(): boolean {
    return this.eventService.isEditable(this.event.publicResponseEnd);
  }

  isExpanded: boolean = false;

  /** The employee has assigned shift(s) for this event → render the minimal (read-only) variant. */
  protected get assigned(): boolean {
    return this.responses.length > 0;
  }

  protected get title(): string {
    return this.event.publicTitle != "" ? this.event.publicTitle : this.event.name;
  }

  /** Response state for the status badge. */
  protected get status(): 'accepted' | 'declined' | 'pending' | 'expired' {
    const a = this.event.employeeEventResponse?.active;
    if (a === true) return 'accepted';
    if (a === false) return 'declined';
    // No response: still open if the window allows it, otherwise the chance has lapsed.
    return this.canRespond() ? 'pending' : 'expired';
  }

  protected get statusLabel(): string {
    switch (this.status) {
      case 'accepted':
        return 'Angenommen';
      case 'declined':
        return 'Abgelehnt';
      case 'expired':
        return 'Abgelaufen';
      default:
        return 'Offen';
    }
  }

  protected get statusClass(): string {
    switch (this.status) {
      case 'accepted':
        return 'bg-green-50 text-green-700 ring-1 ring-green-600/20';
      case 'declined':
        return 'bg-red-50 text-red-700 ring-1 ring-red-600/20';
      case 'expired':
        return 'bg-gray-100 text-gray-500 ring-1 ring-gray-300';
      default:
        return 'bg-amber-50 text-amber-700 ring-1 ring-amber-600/20';
    }
  }
}
